<template>
    <model-manage-container :model-config="modelConfig" :data="data" :prevent-success-action="isPreSaving" v-model:loading="isLoading" ref="manageContainerElement" @success="handleSavedArticle" @reset="reset">
        <article-form-inputs :data="data" :disabled="isLoading"/>

		<template #button>
			<btn :disabled="isPreSaving || isLoading" :loading="isPreSaving" @click="savePreview">
				<span>{{ $t('action.save') }} & {{ $t('label.preview') }}</span>
			</btn>
		</template>
    </model-manage-container>
</template>

<script setup lang="ts">
import {useManageStore} from "../../../../../store/manage";
import {type Article} from "@spoferan/spoferan-ts-core";
import {type Ref} from "vue";

const {$apiFetch} = useNuxtApp();
const {t} = useI18n();
const route = useRoute();
const manageStore = useManageStore();
const baseConfig = useArticleModelConfig(manageStore.user);

const isPreSaving = ref(false);
const existingArticle: Ref<Article | null> = ref(null);

const manageContainerElement = ref(null);

const modelConfig = computed(() => {
	const currentConfig = {...baseConfig};
	if (existingArticle.value) {
		currentConfig.store_ep_resolver = () => baseConfig.update_ep_resolver(existingArticle.value);
		currentConfig.store_method = 'PUT'
	}

	return currentConfig;
});

const {data, isLoading, reset, handleSavedEvent} = useManagePage((data) => {
	data.value = {
		type: 'blog',
		status: 'published',
		links: route.query.links
	}
});

function savePreview() {
	data.value.status = 'draft';
	isPreSaving.value = true;
	manageContainerElement.value.submit().catch((e) => {
		console.warn(e);
	}).finally(() => {
		data.value.status = 'published';
		isPreSaving.value = false;
	});
}

function handleSavedArticle(article) {
	if (isPreSaving.value) {
		window.open(modelConfig.value.show_route_resolver(article), '_blank').focus();
	}
	existingArticle.value = article;

	// The publishing date is automatically set on the API whereby we need to update it
	data.value.published_at = article!.published_at;

	handleSavedEvent();
}

useMeta({
	title: t('view.my.profile.manage.articles.create.title'),
	description: t('view.my.profile.manage.articles.create.description'),
	noIndex: true
})

</script>

